const BrandsPreviewComponent = {
    data() {
        return {
            brands: [],
            loading: false
        }
    },
    methods: {
        async getBrands() {
            this.loading = true;
            try {

                const response = await fetch( window.appConfig.routes.getBrands, {
                    method: 'post',
                    headers: {
                        'X-CSRF-TOKEN': window.appConfig.csrfToken,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        limit: 8
                    })
                });

                const data = await response.json();

                if (response.ok)
                    this.brands = data;

                this.loading = false;

            } catch (error) {

                this.messageError = "Ошибка сети";
                this.loading = false;

            }

        },

        slugify(str) {
            return globalState.slugify( str );
        },
    },
    mounted() {
        this.getBrands();
    },
    computed: {
        showLoading() {
            return this.loading;
        },
        showContent() {
            return !this.loading && this.brands && this.brands.length > 0;
        }
    }
};

window.BrandsPreviewComponent = BrandsPreviewComponent;